<template>
  <div class="page-content-pc">
    <div class="banner gsap-fade-down">
      <div class="introduce">
        <div class="introduce_title">
          智寰科技
        </div>
        <div class="introduce_desc">
          <div>重新定义客户服务：AI驱动，体验升级</div>
        </div>
      </div>
    </div>

    <!-- 公司介绍板块 -->
    <div class="title-box gsap-fade-down">
      <div class="title_text">
        公司介绍
      </div>
    </div>
    <div class="company-introduction">
      <div class="company-section">
        <div class="company-left">
          <div class="about-title">{{ companyIntroData.title }}</div>
          <div class="about-desc">
            <div v-for="(line, i) in companyIntroData.desc" :key="i">{{ line }}</div>
          </div>
          <div class="about-statistics">
            <div class="about-statistics-row" v-for="(row, rowIdx) in companyIntroData.statistics" :key="rowIdx">
              <div class="about-statistics-item gsap-fade-up" v-for="item in row" :key="item.label">
                <div class="about-statistics-value">{{ item.value }}</div>
                <div class="about-statistics-label">{{ item.label }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="company-right">
          <div v-if="!companyVideoPlaying" class="company-cover-wrap">
            <img :src="companyCover" alt="公司介绍封面" class="company-cover-img" />
            <div class="company-play-btn" @click="playcompanyVideo">
              <svg viewBox="0 0 88 88">
                <polygon points="22,10 72,44 22,78" />
              </svg>
            </div>
          </div>
          <div v-else class="company-video-wrap">
            <video :src="companyMp4" controls autoplay loop class="company-video" />
          </div>
        </div>
      </div>
    </div>
    <!-- 公司介绍板块结束 -->

    <!-- 智寰企业文化板块 -->
    <div class="title-box gsap-fade-up">
      <div class="title_text">
        智寰企业文化
      </div>
    </div>
    <div class="statistics-section gsap-fade-up">
      <div class="statistics-inner">
        <div class="statistics-item gsap-fade-up" v-for="(item, idx) in statisticsList" :key="item.title"
          :class="`statistics-item-${idx}`">
          <img :src="item.icon" :alt="item.title" class="statistics-icon" />
          <div class="statistics-info">
            <div class="statistics-value">{{ item.value }}</div>
            <div class="statistics-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="statistics-section-img gsap-fade-up">
      <div class="statistics-section-img-box">
        <img class="bg-top" :src="cultureBgTop" alt="">
      </div>
    </div>
    <!-- 智寰企业文化板块结束 -->

    <!-- 团队实力板块 -->
    <div class="title-box gsap-fade-up">
      <div class="title_text">
        智寰团队实力
      </div>
    </div>
    <div class="team-strength-section gsap-fade-up">
      <div class="team-strength-container">
        <div v-for="item in teamStrengthList" :key="item.title"
          :class="['team-strength-item', item.class, 'gsap-fade-up']">
          <div class="team-strength-title">{{ item.title }}</div>
          <div class="team-strength-desc">
            <div v-for="(line, i) in item.desc" :key="i">{{ line }}</div>
          </div>
        </div>
        <!-- 中间核心成员图 -->
        <div class="team-strength-center gsap-fade-up">
          <img :src="teamStrengthImg" alt="核心成员" class="team-strength-img" />
        </div>
      </div>
    </div>

    <!-- 公司环境 -->
    <div class="title-box gsap-fade-up">
      <div class="title_text">
        公司环境
      </div>
    </div>
    <div class="environment-section">
      <div class="environment-img-wrap">
        <img :src="environmentImg" alt="公司环境" class="environment-img" />
      </div>
      <div class="environment-info">
        <div class="environment-info-title">
          <span class="highlight">{{ environmentData.title }}</span>{{ environmentData.subtitle }}
        </div>
        <div class="environment-info-desc">{{ environmentData.desc }}</div>
        <div class="environment-stats">
          <div class="environment-stat" v-for="item in environmentData.stats" :key="item.label">
            <span class="environment-stat-value">{{ item.value }}<span v-if="item.unit" class="environment-stat-unit">{{
              item.unit }}</span></span>
            <span class="environment-stat-label">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyCover from '../../assets/img/about/pc/company_cover.png'
import companyMp4 from '../../assets/video/company.mp4'

import cultureicon1 from '../../assets/img/about/pc/culture_icon1.png'
import cultureicon2 from '../../assets/img/about/pc/culture_icon2.png'
import cultureicon3 from '../../assets/img/about/pc/culture_icon3.png'
import cultureicon4 from '../../assets/img/about/pc/culture_icon4.png'
import cultureBgTop from '../../assets/img/about/pc/culture_bg_top.png'

import teamStrengthImg from '../../assets/img/about/pc/team_strength_img.png'

import environmentImg from '../../assets/img/about/pc/environment_img.png'

// 新增：引入gsap和ScrollTrigger
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'companyIntroPC',
  data() {
    return {
      // 智寰企业文化数据
      cultureicon1,
      cultureicon2,
      cultureicon3,
      cultureicon4,
      cultureBgTop,


      statisticsList: [
        { title: '成为世界领先的智能交互技术 产品与服务提供商', value: '定位', icon: cultureicon1 },
        { title: '智寰科技让营销更简单', value: '使命', icon: cultureicon2 },
        { title: '持续创新+技术突破+商业落地', value: '经营理念', icon: cultureicon3 },
        { title: '数智化服务引领者', value: '愿景', icon: cultureicon4 }
      ],
      // 公司介绍板块数据
      companyVideoPlaying: false,
      companyCover,
      companyMp4,
      companyIntroData: {
        title: '关于智寰科技',
        desc: [
          '专注人工智能（AI）核心技术（计算机视觉、深度学习、图形学）研发与应用，致力于助力企业智能化升级。公司为各行业量身打造智能化解决方案，通过实现自动化管理与智能决策，有效提升效率、降低成本，达成降本增效目标。',
          '依托央视权威背书及国家级媒体资源，公司成功构建公众信任，实现从技术领先到市场认可的跨越式发展。未来将持续以“持续创新+技术突破+商业落地”三轮驱动战略，打造多领域AI生态系统，为行业智能化转型提供核心支撑。'
        ],
        statistics: [
          [
            { value: '45600+', label: '连接设备' },
            { value: '3500+', label: '注册用户' },
            { value: '268万+', label: '日上传数据量' }
          ],
          [
            { value: '60%', label: '释放人力' },
            { value: '98.5%', label: '客户满意度' },
            { value: '95.14%', label: '问题处理率' }
          ]
        ]
      },

      // 团队实力板块数据
      teamStrengthImg,
      teamStrengthList: [
        {
          class: 'team-strength-topleft',
          title: '技术总监',
          desc: [
            '北京大学计算机科学与技术博士，具备算法工程化能力和商业敏感度，深耕人工智能领域20年，曾担任阿里云事业部技术总监，精通Transformer/GNN/DDPM等架构创新，服务超200家政府与企业客户。持有3项AI模型优化相关发明专利，主导过千万级用户的智能客服系统升级,在人工智能科学顶级学术会议上以第一作者累计发表论文20余篇。'
          ]
        },
        {
          class: 'team-strength-topright',
          title: 'AI产品经理',
          desc: [
            '武汉大学电子信息/自动化+心理学双学位，擅长用户画像与场景拆解，熟悉ISO/IEC 23053,对自然语言处理（NLP）、情感计算、人机交互有独特视角。曾任职大厂，领导10人跨职能团队，主导过用户量级超千万的智能产品，相关论文曾被ACL 2024收录。'
          ]
        },
        {
          class: 'team-strength-bottomleft',
          title: '算法工程师',
          desc: [
            '武汉工程大学计算机科学与技研究生，精通Transformer/GNN/强化学习框架创新，熟悉Docker/K8s部署,精通CUDA优化,8年大厂核心模型研发经验,主导过3个千万级用户规模的AI模型迭代, CCF人工智能会议青年论坛演讲嘉宾。'
          ]
        },
        {
          class: 'team-strength-bottomright',
          title: 'AI 训练工程师',
          desc: [
            '毕业于武汉大学，深耕机器学习、深度学习等核心课程，精通 PyTorch、TensorFlow 等主流框架，擅长分布式训练策略设计与硬件加速优化',
            '主导过 10 余个大型 AI 模型训练项目，涵盖自然语言处理、计算机视觉等多模态领域。'
          ]
        }
      ],

      // 公司环境板块数据
      environmentData: {
        title: '卓越',
        subtitle: '的办公环境',
        desc: '公司坐落于武汉汉口核心区域，武汉市江汉区武汉中央商务区泛海国际SOHO城，坐拥城市黄金中轴线。周边5公里范围内覆盖武汉CBD、武广商圈等顶级资源带',
        stats: [
          { value: '1500', unit: '²', label: '办公室面积' },
          { value: '450+', label: '公司员工' },
          { value: '30+', label: '业务覆盖城市' }
        ]
      },
      environmentImg,
    }
  },
  methods: {
    playcompanyVideo() {
      this.companyVideoPlaying = true;
    },
  },
  mounted() {
    if (gsap && gsap.utils && gsap.fromTo) {
      // 向上淡入
      gsap.utils.toArray('.gsap-fade-up').forEach(el => {
        gsap.fromTo(el,
          { y: 60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });

      // 从左到中间
      gsap.utils.toArray('.gsap-fade-left').forEach(el => {
        gsap.fromTo(el,
          { x: -100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 从右到中间
      gsap.utils.toArray('.gsap-fade-right').forEach(el => {
        gsap.fromTo(el,
          { x: 100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 从上往下淡入
      gsap.utils.toArray('.gsap-fade-down').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
    }
  }
}
</script>
<style scoped lang="scss">
.page-content-pc {
  margin-top: 64px;
  width: 100%;
  min-width: max-content;

  .banner {
    height: 520px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background: url('../../assets/img/about/pc/banner.png') no-repeat center center;
    background-size: cover;
    margin-bottom: 68px;

    .introduce {
      width: 1280px;
      margin: 0 auto;

      .introduce_title {
        font-weight: 800;
        font-size: 64px;
        color: #0051FF;
      }

      .introduce_desc {
        width: 714px;
        font-weight: 800;
        font-size: 36px;
        color: #0051FF;
        margin-top: 35px;
      }
    }
  }

  .title-box {
    display: flex;
    flex-wrap: wrap;
    text-align: center;

    .title_text {
      width: 100%;
      display: inline-block;
      font-weight: 800;
      font-size: 40px;
      line-height: 56px;
      font-style: normal;
      text-transform: none;
      background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
  }

  // 公司介绍板块
  .company-introduction {
    background: url('../../assets/img/about/pc/company_introduction_bg.png') no-repeat center center;
    background-size: cover;
    height: 580px;
    display: flex;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 82px;

    .company-section {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .company-left {
        width: 520px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .about-title {
          font-weight: 800;
          font-size: 36px;
          color: #0051FF;
          margin-bottom: 9px;
        }

        .about-desc {
          font-weight: 500;
          font-size: 14px;
          color: #6F6F6F;
          margin-bottom: 28px;
          letter-spacing: 0.2px;
        }

        .about-statistics {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 18px;

          .about-statistics-row {
            display: flex;
            flex-direction: row;
            width: 100%;

            .about-statistics-item {
              font-weight: 800;
              color: #333333;
              width: 25%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-right: 52px;

              .about-statistics-value {
                font-size: 32px;
                margin-bottom: 8px;
              }

              .about-statistics-label {

                font-size: 16px;
                letter-spacing: 0.2px;
              }
            }


          }


        }


      }

      .company-right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 736px;
        height: 430px;
        // border: 18px solid #fff;
        overflow: hidden;
        border-radius: 12px;
        padding: 18px;
        background: #fff;
        box-sizing: border-box;

        .company-cover-wrap {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          .company-cover-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }

          .company-play-btn {
            width: 88px;
            height: 88px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 50%;
            box-shadow: 0 4px 16px 0 rgba(0, 81, 255, 0.12);
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            z-index: 2;
            transition: box-shadow 0.2s, transform 0.2s;
            border: none;

            &:hover {
              box-shadow: 0 8px 24px 0 rgba(0, 81, 255, 0.18);
              transform: translate(-50%, -50%) scale(1.08);
            }

            svg {
              width: 44px !important;
              height: 44px !important;
              min-width: 44px;
              min-height: 44px;
              max-width: 44px;
              max-height: 44px;
              display: block;
              margin: 0 auto;
              padding: 0;
            }

            polygon {
              fill: #1677FF;
            }
          }
        }

        .company-video-wrap {
          width: 100%;
          // height: 430px;
          display: flex;
          align-items: center;
          justify-content: center;

          .company-video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 12px;
          }

          display: block;
        }
      }
    }
  }


  // 智寰企业文化板块
  .statistics-section {
    width: 1280px;
    margin: 0 auto;
    margin-top: 54px;
    margin-bottom: 80px;

    .statistics-inner {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .statistics-item {
        min-width: 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        overflow: hidden;
      }

      .statistics-info {
        width: 100%;
        word-break: break-all;
        white-space: normal;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .statistics-item {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        text-align: center;

        .statistics-icon {
          width: 100px;
          height: 100px;
          margin-right: 12px;
          object-fit: contain;
          flex-shrink: 0;
        }

        .statistics-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }

        .statistics-value {
          font-weight: 800;
          font-size: 32px;
          color: #333333;
          text-align: center;
          width: 100%;
        }

        .statistics-title {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          margin-top: 8px;
          width: 100%;
          text-align: center;
        }
      }

      .statistics-item-0 .statistics-info {
        width: 208px;
      }

      .statistics-item-1 .statistics-info {
        width: 160px;
      }

      .statistics-item-2 .statistics-info {
        width: 212px;
      }

      .statistics-item-3 .statistics-info {
        width: 128px;
      }
    }


  }

  .statistics-section-img {
    width: 100%;
    height: 620px;
    background: url('../../assets/img/about/pc/culture_bg.png') no-repeat center center;
    background-size: cover;
    margin-bottom: 88px;
    display: flex;
    align-items: center;
    user-select: none;

    .statistics-section-img-box {
      margin: 0 auto;
      width: 1280px;
      height: 444px;


      .bg-top {
        width: 100%;
        height: 100%;


      }
    }
  }

  // 团队实力板块
  .team-strength-section {
    width: 1280px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 68px;
    margin-top: 50px;

    .team-strength-container {
      position: relative;
      width: 100%;
      height: 415px;

      .team-strength-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) !important;
        width: 415px;
        height: 415px;
        user-select: none;

        .team-strength-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          user-select: none;
        }
      }

      .team-strength-item {
        position: absolute;
        width: calc((100% - 415px) / 2);
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        z-index: 1;
      }

      .team-strength-topleft {
        left: 0;
        top: 0;
        text-align: left;
      }

      .team-strength-topright {
        right: 0;
        top: 0;
        text-align: left;
      }

      .team-strength-bottomleft {
        left: 0;
        bottom: 0;
        text-align: left;
      }

      .team-strength-bottomright {
        right: 0;
        bottom: 0;
        text-align: left;
      }

      .team-strength-title {
        width: 100%;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        border-bottom: 1px solid #5A9AEC;
        margin-bottom: 10px;
        letter-spacing: 1px;
      }

      .team-strength-desc {
        font-weight: 500;
        font-size: 16px;
        color: #6F6F6F;
        letter-spacing: 0.2px;
        word-break: break-all;
      }

      .team-strength-topleft .team-strength-title,
      .team-strength-bottomleft .team-strength-title {
        text-align: left;
        border-bottom: 1px solid #5A9AEC;
        margin-bottom: 10px;
        margin-left: 0;
        margin-right: auto;
      }

      .team-strength-topright .team-strength-title,
      .team-strength-bottomright .team-strength-title {
        text-align: right;
        border-bottom: 1px solid #5A9AEC;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: 0;
      }
    }
  }

  //  公司环境
  .environment-section {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 110px;
    margin-top: 54px;
    margin-bottom: 74px;

    .environment-img-wrap {
      width: 703px;
      height: 454px;
      flex-shrink: 0;
      border-radius: 20px;
      overflow: hidden;

      .environment-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .environment-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .environment-info-title {
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        margin-bottom: 40px;

        .highlight {
          color: #1677FF;
        }
      }
    }

    .environment-info-desc {
      width: 429px;
      font-weight: 500;
      font-size: 16px;
      color: #606060;
      margin-bottom: 47px;
    }

    .environment-stats {
      display: flex;
      flex-direction: row;
      gap: 78px;

      .environment-stat {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 90px;

        .environment-stat-value {
          position: relative;
          font-weight: 800;
          font-size: 32px;
          color: #333333;
          margin-bottom: 8px;

          .environment-stat-unit {
            position: absolute;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            margin-left: 2px;
            top: 0px;
          }
        }

        .environment-stat-label {
          font-weight: 800;
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
}
</style>